export default "__VITE_ASSET__6ad2d45b__"